import { useTranslation } from 'next-i18next';
import { Suspense } from 'react';

import { DeferredComponent } from '../../../../util/DeferredComponent';
import { SettingSection } from '../common/SettingSection';
import { SectionSkeleton } from './SectionSkeleton';
import { EmailSettingRow } from './basic/EmailSettingRow';
import { PasswordSettingRow } from './basic/PasswordSettingRow/PasswordSettingRow';
import { PhoneSettingRow } from './basic/PhoneSettingRow';
import { useSettingEdit } from './basic/useSettingEdit';

export const EDIT_TARGET = {
  EMAIL: 'email',
  PASSWORD: 'password',
  PHONE: 'phone',
} as const;

export type EditTarget = (typeof EDIT_TARGET)[keyof typeof EDIT_TARGET];

export interface BasicSectionRowProps {
  showEditButton: boolean;
  onClose: () => void;
  onClick: () => void;
  isEditMode: boolean;
}

export const BasicSection = () => {
  const { t } = useTranslation();

  return (
    <SettingSection title={t('기본 정보')}>
      <Suspense
        fallback={
          <DeferredComponent>
            <SectionSkeleton lines={3} />
          </DeferredComponent>
        }
      >
        <_BasicSection />
      </Suspense>
    </SettingSection>
  );
};

const _BasicSection = () => {
  const { register } = useSettingEdit<EditTarget>();

  return (
    <>
      <EmailSettingRow {...register(EDIT_TARGET.EMAIL)} />
      <PasswordSettingRow {...register(EDIT_TARGET.PASSWORD)} />
      <PhoneSettingRow {...register(EDIT_TARGET.PHONE)} />
    </>
  );
};
